import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { t } from "ttag";

import { BreakPoint } from "../../../models/screen.interfaces";
import { getViewportBreakpoint } from "../../../utils/detectMobile";
import { GridFilterConfig } from "../filters";
import { GridFilter, GridFilterVariants } from "./GridFilter";

import styles from "./SideNav.module.scss";

interface IOwnProps {
    gridVariant: string;
    filters: GridFilterConfig[];
}

const SideNav = React.memo(
    ({ gridVariant: _gridVariant, filters }: IOwnProps): React.ReactNode => {
        const [showFilters, setShowFilters] = useState(true);

        const isMobileOrTabletWidth = () => {
            const currentBreakpoint = getViewportBreakpoint();
            return currentBreakpoint < BreakPoint.LARGE;
        };

        const toggleFilterView = (event: React.MouseEvent<HTMLDivElement>) => {
            event.preventDefault();
            setShowFilters(!showFilters);
        };

        useEffect(() => {
            if (isMobileOrTabletWidth()) {
                setShowFilters(false);
            }
        }, []);

        const renderTitle = () => {
            const titleText = t`Filters`;
            const filterTitleToggleClass = classNames({
                [styles.title]: true,
                [styles.open]: showFilters,
                [styles.close]: !showFilters,
            });

            if (isMobileOrTabletWidth()) {
                return (
                    <div
                        className={filterTitleToggleClass}
                        onClick={toggleFilterView}
                    >
                        {titleText}
                    </div>
                );
            }

            return <h2 className={styles.title}>{titleText}</h2>;
        };

        return (
            <div className={styles.container}>
                {renderTitle()}
                {showFilters && (
                    <div>
                        {filters.map((config) => (
                            <GridFilter
                                key={config.filterID}
                                config={config}
                                variant={GridFilterVariants.ACCORDION}
                                showSelectedList={false}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    },
);

SideNav.displayName = "SideNav";

export { SideNav };
